import '@/app/app.css';
import './main.css';

import '@/app/app';
import '@/layouts/main/main';

import { SwiperBanner } from '@/shared/swiper/swiper-banner/swiper-banner';
import { SwiperCarousel } from '@/shared/swiper/swiper-carousel/swiper-carousel';

window.app.SwiperBanner = SwiperBanner;
window.app.SwiperCarousel = SwiperCarousel;

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-swiper-banner').forEach((element) => {
		new SwiperBanner(element);
	});

	document.querySelectorAll('.js-swiper-carousel').forEach((element) => {
		new SwiperCarousel(element);
	});

	document.querySelectorAll('.js-look-carousel').forEach((element) => {
		new SwiperCarousel(element, {
			breakpoints: {
				[vars.breakpoint.desktop]: {
					slidesOffsetAfter: 0,
					slidesOffsetBefore: 0,
					slidesPerView: 4,
				},
			},
		});
	});
});
